import Vue from 'vue';
import Vuex from 'vuex';
// import 'es6-promise/auto';
import layout from './modules/layout';
import menu from './modules/menu';
import chat from './modules/chat';
import products from './modules/products';
import email from './modules/email';
import todo from './modules/todo';
import firebase_todo from './modules/firebase_todo';
import jobs from './modules/jobs';
import courses from './modules/courses';
import common from './modules/common';
import { alert } from './modules/alert';
import { authentication } from './modules/authentication';
import { users } from './modules/users';

// QuickCV
import packages from './modules/quickCV/package.js';
import coupon from './modules/quickCV/coupon.js';
import referral from './modules/quickCV/referral.js';
import coin from './modules/quickCV/coin.js';
import payment from './modules/quickCV/payment.js';
import subscriber from './modules/quickCV/subscriber.js';
import dashboard from './modules/quickCV/dashboard.js';
import label from './modules/quickCV/label.js';
import language from './modules/quickCV/language.js';
import skill from './modules/quickCV/skill.js';
import feedback from './modules/quickCV/feedback.js';
import key from './modules/quickCV/key.js';
import course from './modules/quickCV/course.js';
import partner from './modules/quickCV/partner.js';
import sidebar from './modules/quickCV/sidebar.js';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {},

    mutations: {
        changeLang (state, payload) {
            localStorage.setItem('currentLanguage', payload.id);
            localStorage.setItem('currentLanguageIcon', payload.icon);
            window.location.reload();
        }
    },

    actions: {
        setLang ({ commit }, payload) {
            commit('changeLang', payload);
        }
    },

    modules: {
        alert,
        authentication,
        users,
        layout,
        chat,
        menu,
        products,
        email,
        todo,
        firebase_todo,
        jobs,
        courses,
        common,

        // QuickCV
        packages,
        coupon,
        referral,
        coin,
        payment,
        subscriber,
        dashboard,
        label,
        language,
        skill,
        feedback,
        key,
        course,
        partner,
        sidebar
    }
});

